import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MiniLoading from "./MiniLoading";
import moment from "moment/min/moment-with-locales";
import { Trans, useTranslation } from "react-i18next";


const Row = ({ data }) => {
  const { t } = useTranslation();
  const frequent = data.frequent / 60;

  return (
    <TableRow
      key={data.ID}
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
      }}
    >
      <TableCell component="th" scope="row">
        {data.id}
      </TableCell>
      <TableCell sx={{
        textTransform: "lowercase",
        "::first-letter": {
          textTransform: "uppercase"
        }
      }}>{data.type.replaceAll('_', ' ')}</TableCell>
      <TableCell><Trans i18nKey="frequent" frequent={frequent}>Every {{ frequent }} minutes</Trans></TableCell>
      <TableCell>{moment(data.sync?.last_sync ?? moment().locale('nl')).add(data.frequent, 'seconds').locale('nl').format('LLL')}</TableCell>
      <TableCell>{data.enabled ? t('Yes') : t('No')}</TableCell>
      <TableCell>{data.data_count}</TableCell>
    </TableRow>
  );
};

export default function CronsTable(props) {
  const Alert = (props) => (
    <TableRow>
      <TableCell colSpan={6} sx={{ textAlign: "center" }}>
        {props.message}
      </TableCell>
    </TableRow>
  );
  const { t } = useTranslation();

  return (
    <>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }}>
          <TableHead>
            <TableRow>
              <TableCell>{t("Id")}</TableCell>
              <TableCell>{t("Type")}</TableCell>
              <TableCell>{t("Frequent")}</TableCell>
              <TableCell>{t("Next Run")}</TableCell>
              <TableCell>{t("Enabled")}</TableCell>
              <TableCell>{t("Data Count")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.data == null ? (
              <TableRow>
                <TableCell colSpan={6}>
                  <MiniLoading />
                </TableCell>
              </TableRow>
            ) : (
              <>
                {
                  props.data.data.length === 0 && <Alert message={t("There are no crons.")} />}
                {props.data.data?.map((row) => (
                  <Row
                    key={row.ID}
                    data={row}
                  />
                ))}
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}
